module.exports = __webpack_public_path__ + "img/pabbly.ed95749b.png";